import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { api } from "../apiClient";

export const generatePayload = (classData, member_id, processed_date) => {
  return {
    classes: Object.values(classData).map(val => {
      return {
        id: val.id,
        class: val.class,
      };
    }),
    member_id,
    processed_date,
  };
};

export const postMemberClassesAssign = data => {
  return api.post(`admin/member-class-assign`, data);
};

export const postMemberClassesAssignQueryOptions = (data, meta) => {
  return queryOptions({
    queryKey: ["member-class-assign", data],
    queryFn: () => postMemberClassesAssign(data),
    meta,
  });
};

export const usePostMemberClassesAssignMutation = ({ mutationConfig }) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: async (data, ...args) => {
      await onSuccess?.(data, ...args);
      queryClient.invalidateQueries();
    },
    ...restConfig,
    mutationFn: postMemberClassesAssign,
  });
};
